import moment from "moment";
import React from "react";
import { useLocation } from "react-router-dom";

const NotificationDetails = () => {
  const location = useLocation();
  const { item } = location.state;
  return (
    <ul>
      <li><strong>Title: </strong>{item.title}</li>
      <li><strong>Content: </strong>{item.content}</li>
      <li><strong>Date: </strong>{moment(item.date).format("D MMM, YYYY")}</li>
  </ul>
  );
};

export default NotificationDetails;
